import React,{useState} from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../actions/Actions.js';
import StyleSliderItem from "../components/StyleSliderItem.js"
import LazyLoad from 'react-lazyload';
import StyleModal from '../components/StyleModal.js';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Helmet} from "react-helmet";

const loadStyle=(style_id)=>{
  let stylePromise=fetch(
    __server__ + '/API/pub/style/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())

  let colorwaysPromise=fetch(
    __server__ + '/API/pub/colorways_by_style_id/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())

  let resellsPromise=fetch(
    __server__ + '/API/pub/resells_by_style_id/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())


  return(
    Promise.all([stylePromise,colorwaysPromise,resellsPromise]).then(([style,colorways,resells])=>{
      return({...style[0],colorways:colorways,resells:resells})
    })
  )
}




function LikePage(props){
  const [showModal, setShowModal] = useState(false);
  const [activeStyle,setActiveStyle]=useState({});
  const [loadedStyles,setLoadedStyles]=useState([]);


  const fetchData=(style_id)=>{
    loadStyle(style_id).then((style)=>{
      setLoadedStyles((prevState)=>prevState.concat(style));
    })
  }

  const onLikeCounterChange=(style_id,change)=>{
    setActiveStyle((prevState)=>({
      ...prevState,
      likes:Number(prevState.likes)+change
    }))
  }


  return(
    <div>
      <Helmet>
        <title>Liked Basketball Shoe Styles:</title>
      </Helmet>
      <h1>Your Favorite Styles:</h1>
      <div id="like_container" style={{minHeight:"100vh",marginRight:-10}}>

        <Modal dialogClassName="thg_style_modal" onHide={()=>{setShowModal(false)}} show={showModal}>
          <StyleModal onLikeCounterChange={onLikeCounterChange} linkId={"likes"} hideModal={()=>{setShowModal(false)}} activeStyle={activeStyle}/>
        </Modal>
        {props.likes.length===0 &&
          <div style={{fontSize:18,marginTop:20}}>
            <div>No colorways liked so far.</div>
            <div>Click the
              <i style={{color:"#999999",margin:"0px 5px"}} className="far fa-heart"/>
              button to add shoes.
            </div>
          </div>
        }
        <Row style={{marginTop:10}}>
          {props.likes.map((like)=>
            {
              let tempStyleItem=loadedStyles.filter((style)=>style.style_id===like.style_id)[0];
              let styleItem=tempStyleItem || {};
              let preview=tempStyleItem ? false :true;

              return(
                <LazyLoad placeholder={<div style={{minHeight:200}}/>} key={like.style_id}>
                  <Col lg={2} md={3} sm={4} xs={6}  style={{padding:"0px 5px",marginBottom:50,}}>
                    <StyleSliderItem
                      responsive
                      fetchData={()=>fetchData(like.style_id)}
                      preview={preview}
                      styleItem={styleItem}
                      onClick={()=>{setShowModal(true);setActiveStyle(styleItem)}}
                      textContainerStyle={{padding:"5px 20px 10px 5px"}}
                      key={like.style_id}
                      style_id={like.style_id}
                      showShoeName
                      showLikeButton={false}
                      imageProps={{padding:"5% 8%"}}

                        />
                  </Col>
                </LazyLoad>
              );
            }
          )}
        </Row>
      </div>
    </div>
  );
}


  export default connect(state => ({
    likes:state.persistData.likes
  }), (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch)
  }))(LikePage);
